An array of `Location` identifiers.

A maximum of 10 locations may be provided.
